import t from "./Selectable.mjs";
import { SelectableType as a } from "./Selectable.mjs";
import "../../../jsx-runtime-c20f6c15.mjs";
import "react";
import "clsx";
import "../../../shared/icons/select.svg.mjs";
export {
  a as SelectableType,
  t as default
};
